import { usePrefetchNotificationsData } from '@/components/AppHeader/hooks/useNotificationsData';
import { usePrefetchCategories as usePrefetchChatbotCategories } from '@/components/ChatBot';
import { usePrefetchAppLibraryData } from '@/components/ConnectApps/Common/appLibraryData';
import { usePrefetchUploadConfig } from '@/components/FileUpload';
import { usePrefetchChannels } from '@/features/Channels/hooks/useFetchChannels';
import { usePrefetchOrganizationInfo } from '@/features/Channels/hooks/useFetchOrganization';
import { usePrefetchAllNotebooks } from '@/features/Notes/hooks/useFetchNotebooks';
import { usePrefetchCompanyFilter } from '@/features/PortfolioManager/hooks/useFetchCompanyFilter';
import { usePrefetchPrivateApps } from '@/hooks/query/useFetchPrivateApps';

import { usePrefetchConfigUI } from './useFeatureConfig';
import { usePrefetchCategories } from './useFetchCategories';
import { usePrefetchFeeds } from './useFetchFeeds';
import { usePrefetchNeedlbox } from './useFetchNeedlbox';
import { usePrefetchPublicApps } from './useFetchPublicApps';
import { usePrefetchUserOnboardingFlags } from './useFetchUserOnboardingFlags';
import { usePrefetchUserData } from './useUserData';
import { useUserStatusPrefetch } from './useUserStatus';
import { usePrefetchWorkspaces } from './useWorkspaces';

export const usePrefetchInitialData = () => {
  useUserStatusPrefetch();
  usePrefetchUserOnboardingFlags();
  usePrefetchFeeds();
  usePrefetchNeedlbox();
  usePrefetchPublicApps();
  usePrefetchChannels();
  usePrefetchPrivateApps();
  usePrefetchAllNotebooks();
  usePrefetchAppLibraryData();
  usePrefetchNotificationsData();
  usePrefetchUserData();
  usePrefetchChatbotCategories();
  usePrefetchUploadConfig();
  usePrefetchOrganizationInfo();
  usePrefetchCategories();
  usePrefetchCompanyFilter();
  usePrefetchConfigUI();
  usePrefetchWorkspaces();
};
